import { render } from "./Event.vue?vue&type=template&id=43a029f3&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=43a029f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a029f3"]])

export default __exports__